import React from "react"
import { useTranslation } from "react-i18next"

import IconSvg from "@atoms/IconSvg/IconSvg"
import closeIcon from "@images/svg/close.svg"

const ResetFiltersButton = ({ onClick }) => {
  const { t } = useTranslation()

  return (
    <button
      className="inline-flex justify-center items-center rounded-full font-medium text-sm leading-3 border-2 text-blue-900 bg-white border-blue-900 hover:bg-gray-100 py-2.5 px-3.5 transition-colors"
      onClick={onClick}
    >
      {t("Clear all")}
      <IconSvg
        Icon={closeIcon}
        widthClass="w-3.8 text-blue-900 align-middle "
      />
    </button>
  )
}

export default ResetFiltersButton
